export const isTestMode = () => {
  return (
    window.location.href.includes('mixer') ||
    window.location.href.includes('localhost')
  );
};
